import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EquisButtonModule } from '@tn-equis/core/components/button';

import { LinkComponent } from './link.component';

@NgModule({
  declarations: [LinkComponent],
  imports: [CommonModule, EquisButtonModule],
  exports: [LinkComponent],
})
export default class LinkModule {
  public static component = LinkComponent;
}
